import React from 'react'
import { feedbotToast } from '../../../../../lib/feedbotToast'

export const toastNotifyDeleteNlpLogSuccess = (query: string) => {
  const id = `nlp-delete-${query}`
  const title = 'Deleting utterance successful'
  const content = `The following unmatched utterance was successfully deleted: ${query}`

  feedbotToast.success({ title, content, id })
}

export const toastNotifyDeleteAllNlpLogsSuccess = () => {
  const id = 'nlp-delete-all'
  const title = 'Deleting all utterances successful'
  const content = 'All unmatched utterances was successfully deleted.'

  feedbotToast.success({ title, content, id })
}

export const toastNotifyDeleteNlpLogError = (utterance: string) => {
  const id = 'nlpDeleteError'
  const title = 'Deleting utterance failed'

  const content = (
    <>
      We were unable to delete the following unmatched utterance: {utterance}. Please, try it again
      or contact{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://feedyou.atlassian.net/servicedesk/customer/portals"
      >
        our support
      </a>
      .
    </>
  )

  feedbotToast.error({ title, content, id })
}

export const toastNotifyDeleteAllNlpLogsError = () => {
  const id = 'nlpDeleteAllError'
  const title = 'Deleting all utterances failed'

  const content = (
    <>
      We were unable to delete all unmatched utterances. Please, try it again or contact{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://feedyou.atlassian.net/servicedesk/customer/portals"
      >
        our support
      </a>
      .
    </>
  )

  feedbotToast.error({ title, content, id })
}
